export default __webpack_public_path__ + "static/media/invoices.06b6fabd.svg";